import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useCallback, useEffect, useRef, useState } from "react";
import DetailedEvaluation from "./refereeSummary/DetailedEvaluation";
import FinalRecommendation from "./refereeSummary/FinalRecommendation";
import GradingSummary from "./refereeSummary/GradingSummary";
import ProposalDetails from "./refereeSummary/ProposalDetails";
import service from "../Helpers/gifservices";
import { useReactToPrint } from "react-to-print";
import { useLoading } from "../../../providers/loadingProvider";

const useStyles = makeStyles((theme) => ({
  printButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: "#FFFFFF",
    backgroundColor: theme.palette.gif.blue.color,
    width: 120,
    marginTop: 15,
    marginLeft: 6,
    borderRadius: 8,
  },
  closeButton: {
    marginLeft: 15,
    width: 120,
    marginTop: 15,
    borderRadius: 8,
  },
  parentContainer: {
    "@media print": {
      display: "block",
    },
  },
}));

export default function RefereeSummaryModal(props) {
  const classes = useStyles();
  const { open, onClose, proposalRefereeId } = props;
  const componentRef = useRef();
  const loading = useLoading();
  const [proposalReferee, setProposalReferee] = useState();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const GetProposalReferee = useCallback(async () => {
    if (!proposalRefereeId) return;
    const loadingId = loading.addLoading("Loading Proposal");

    var proposalReferee = await service.GetProposalRefereeById({
      proposalRefereeId,
    });
    setProposalReferee(proposalReferee);
    loading.removeLoading(loadingId);
  }, [proposalRefereeId, loading]);

  useEffect(() => {
    if (!open) return;
    GetProposalReferee();
  }, [proposalRefereeId, GetProposalReferee, open]);

  return (
    <div>
      <Dialog open={open} onClose={onClose} scroll="paper">
        <DialogContent dividers>
          <DialogContentText>
            <Grid
              container
              spacing={1}
              ref={componentRef}
              className={classes.parentContainer}
            >
              <Grid item xs={12}>
                <ProposalDetails proposalReferee={proposalReferee} />
              </Grid>
              <Grid item xs={12}>
                <DetailedEvaluation proposalReferee={proposalReferee} />
              </Grid>
              <Grid item xs={12}>
                <div style={{ pageBreakBefore: "always" }}>
                  <GradingSummary proposalReferee={proposalReferee} />
                </div>
              </Grid>
              <Grid item xs={12}>
                <FinalRecommendation proposalReferee={proposalReferee} />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disableElevation
            variant="contained"
            className={classes.closeButton}
            onClick={onClose}
          >
            Close
          </Button>
          <Button
            disableElevation
            variant="contained"
            className={classes.printButton}
            onClick={handlePrint}
          >
            Print
          </Button>
        </DialogActions>
      </Dialog>
      </div>
  );
}
